import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import Typography from "@material-ui/core/Typography";

import withStyles from "@material-ui/styles/withStyles";

import shootService from "../../../services/shootService";
import ReviewShotShootStep from "./ReviewShotShootStep";
//components
import SelectShotsStep from "./SelectShotsStep";
import SelectPriorityShotStep from "./SelectPriorityShotStep";
import SelectPackageTable from "./Table/SelectPackageTable";

import update from "immutability-helper";
import SelectPackageStep from "./SelectPackageStep";
import shotService from "../../../services/shotService";
import AdminWrapper from "../../../containers/AdminWrapper";
import ContentWrapper from "../../../containers/ContentWrapper";

const styles = theme => ({
  button: {
    marginRight: theme.spacing.unit
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  }
});

class EditShotShootSteppers extends Component {
  state = {
    activeStep: 0,
    skipped: new Set(),
    fetching: true,
    failed: false,
    packages: [],
    selectedPackage: null,
    shots: [], //source of all shots
    selectedShots: [], //array of all selectshot ids
    selectedShotPriority: [], //array of all selected priority ids
    reviewShots: [],
    submitting: false,
    selectedFilter: "",
    packageNotFound: false
  };

  componentDidMount() {
    this.initialLoad();
    // this.getShots();
    // this.getPackages();
  }

  initialLoad = async () => {
    try {
      let { clinic, created_at, id } = this.props.match.params;
      let { data } = await shootService.getOneShootPackage({
        clinic,
        created_at,
        id
      });
      this.setState(
        {
          type: data.type
        },
        () => this.getShots()
      );
    } catch (err) {
      if (err.response.status === 404) {
        this.setState({
          fetching: false,
          failed: true,
          packageNotFound: true
        });
      } else {
        this.setState({
          fetching: false,
          failed: true
        });
      }
    }
  };

  handleSelectPackage = id => {
    if (id === this.state.selectedPackage) this.setState({ selectedPackage: "" });
    else this.setState({ selectedPackage: id });
  };

  handleSelectedShot = id => {
    let { selectedShots } = this.state;

    if (selectedShots.includes(id)) {
      let index = selectedShots.indexOf(id);
      console.log(selectedShots);
      let newOutput = update({ selectedShots }, { selectedShots: { $splice: [[index, 1]] } });
      selectedShots = newOutput.selectedShots;
    } else {
      selectedShots = selectedShots.concat(id);
    }
    this.setState({ selectedShots });
  };

  handleSelectPriorityShot = id => {
    let { selectedShotPriority } = this.state;

    if (selectedShotPriority.includes(id)) {
      let index = selectedShotPriority.indexOf(id);
      console.log(selectedShotPriority);
      let newOutput = update({ selectedShotPriority }, { selectedShotPriority: { $splice: [[index, 1]] } });
      selectedShotPriority = newOutput.selectedShotPriority;
    } else {
      selectedShotPriority = selectedShotPriority.concat(id);
    }
    this.setState({ selectedShotPriority });
  };

  onSelectedAll = (property, sourceProperty, filterProperty) => {
    console.log(property, sourceProperty, filterProperty);
    let selectedSource = this.state[property];
    let source = this.state[sourceProperty];
    console.log(selectedSource, source, filterProperty);
    if (source.length !== selectedSource.length) {
      if (this.state.selectedFilter) {
        source = source.filter(item => item[filterProperty] == this.state.selectedFilter);
      }
      source = source.map(item => {
        return item.id;
      });
    } else {
      source = [];
    }
    console.log(selectedSource, source, filterProperty);
    this.setState({ [property]: source });
  };

  handleFilter = (e, property, sourceProperty, filterProperty) => {
    if (e) {
      let selectedSource = this.state[property];
      let source = this.state[sourceProperty];

      source = source.filter(item => item.scene == e && selectedSource.includes(item.id));
      source = source.map(item => {
        return item.id;
      });

      this.setState({ selectedFilter: e, [property]: source });
    } else this.setState({ selectedFilter: e });
  };

  getPackages = async () => {
    try {
      let { data } = await shotService.getPackages({
        params: {
          type: this.props.type
        }
      });
      this.setState({ packages: data, fetching: false, failed: false });
      let packages = data.map(item => {
        item.selected = false;
        return item;
      });
      console.log(data);
      this.setState({ packages });
    } catch (err) {
      console.log("get shots failed: ", err);
      this.setState({
        failed: true,
        fetching: false
      });
    }
  };

  getShots = async () => {
    try {
      let { clinic, created_at } = this.props.match.params;
      if (!this.state.fetching) this.setState({ fetching: true });

      let getShots = await shootService.getOneShootPackageShotsWithStatus({
        clinic,
        created_at,
        id: this.props.match.params.id
      });
      let selectedShots = getShots.data.reduce((output, item) => {
        if (item.selected) return output.concat(item.id);
        else return output;
      }, []);

      this.setState({
        shots: getShots.data,
        selectedShots,
        fetching: false,
        failed: false
      });
    } catch (error) {
      console.log("get shots failed: ", error);
      this.setState({
        failed: true,
        fetching: false
      });
    }
  };

  submitShots = async () => {
    try {
      // console.log(this.state.selectedShots);
      this.setState({ submitting: true });
      let selectedPackage = await shotService.getOnePackage(this.props.match.params.id);
      let shots = this.state.shots.map(item => {
        item.selected = this.state.selectedShots.includes(item.id);
        item.priority = this.state.selectedShotPriority.includes(item.id);
        return item;
      });
      let result = await shootService.addPackageToShoot(
        {
          clinic: this.props.match.params.clinic,
          created_at: this.props.match.params.created_at
        },
        {
          ...selectedPackage.data,
          shots
        }
      );
      console.log(result);
      let { clinic, created_at, id } = this.props.match.params;
      this.setState({ submitting: false });
      this.props.history.replace(`/shoots/view/${clinic}/${created_at}/${this.state.type}`);
    } catch (err) {
      this.setState({ submitting: false });
    }
  };

  handleNext = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1
    });
  };

  handleBack = () => {
    this.setState({
      activeStep: this.state.activeStep - 1
    });
  };

  getSteps() {
    return ["Select Shots for the shoot", "Mark Shot Priority", "Review shots"];
  }

  proceedToReview = () => {
    let { selectedShotPriority, reviewShots } = this.state;
    reviewShots = reviewShots.map(shot => {
      shot.selected = true;
      if (selectedShotPriority.includes(shot.id)) shot.priority = true;
      else shot.priority = false;
      return shot;
    });
    this.setState(
      {
        reviewShots
      },
      () => this.handleNext()
    );
  };

  proceedToSelectShots = () => {
    this.setState(
      {
        selectedFilter: ""
      },
      () => {
        this.getShots();
        this.handleNext();
      }
    );
  };

  proceedToSelectPiority = () => {
    let { selectedShots } = this.state;
    let shots = this.state.shots.filter(item => selectedShots.includes(item.id));
    let selectedShotPriority = shots.filter(item => item.priority).map(item => item.id);
    this.setState({ selectedFilter: "", reviewShots: shots, selectedShotPriority });
    this.handleNext();
  };

  getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <SelectShotsStep
            shots={this.state.shots}
            selectedShots={this.state.selectedShots}
            fetching={this.state.fetching}
            failed={this.state.failed}
            getShots={this.getShots}
            handleSelectedShot={this.handleSelectedShot}
            proceedToReview={this.proceedToReview}
            goBackStep={this.handleBack}
            selectedAll={this.state.selectedAll}
            onSelectedAll={this.onSelectedAll}
            type={this.state.type}
            handleFilter={this.handleFilter}
            selectedFilter={this.state.selectedFilter}
            allowNext={this.state.selectedShots.length > 0 ? true : false}
            handleNext={this.proceedToSelectPiority}
          />
        );
      case 1:
        return (
          <SelectPriorityShotStep
            shots={this.state.reviewShots}
            selectedShots={this.state.selectedShotPriority}
            fetching={this.state.fetching}
            failed={this.state.failed}
            getShots={this.getShots}
            handleSelectedShot={this.handleSelectPriorityShot}
            goBackStep={this.handleBack}
            type={this.state.type}
            selectedAll={this.state.selectedAll}
            onSelectedAll={this.onSelectedAll}
            handleFilter={this.handleFilter}
            handleBack={this.handleBack}
            setStateValue={this.setState}
            selectedFilter={this.state.selectedFilter}
            noFilter={true}
            allowNext={true}
            handleNext={this.proceedToReview}
          />
        );
      case 2:
        return (
          <ReviewShotShootStep
            goBackStep={this.handleBack}
            shots={this.state.reviewShots}
            submitShots={this.submitShots}
            type={this.state.type}
            submitting={this.state.submitting}
          />
        );
      default:
        return "Unknown step";
    }
  }

  render() {
    const { classes } = this.props;
    let { clinic, created_at, id } = this.props.match.params;
    const steps = this.getSteps();
    const { activeStep } = this.state;
    // console.log(this.state.selectedFilter);
    if (this.state.packageNotFound) {
      return (
        <AdminWrapper {...this.props}>
          <ContentWrapper hasHeader title="Edit Shoot Package">
            <div style={{ padding: "50px 0", textAlign: "center" }}>
              <Typography variant="h5" align="center">
                You have not added this package.
              </Typography>
              <div>
                <Button color="primary" variant="contained" style={{ marginTop: 20, marginRight: 5 }} onClick={this.props.history.goBack}>
                  Go Back
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ marginTop: 20, marginLeft: 5 }}
                  onClick={() => this.props.history.replace(`/shoot/view/${clinic}/${created_at}`)}
                >
                  Go to Shoot
                </Button>
              </div>
            </div>
          </ContentWrapper>
        </AdminWrapper>
      );
    } else
      return (
        <AdminWrapper {...this.props}>
          <ContentWrapper hasHeader title="Edit Shoot Package">
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label, index) => {
                return (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            <div style={{ backgroundColor: "#fff" }}>
              {activeStep === steps.length ? (
                <div>
                  <Typography className={classes.instructions}>All steps completed - you&apos;re finished</Typography>
                </div>
              ) : (
                this.getStepContent(activeStep)
              )}
            </div>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "30px 0",
                flexDirection: "column"
              }}
            >
              <Typography variant="display3" style={{ margin: "20px 0" }}>
                You have selected all shots
              </Typography>
              <Button variant="contained" color="primary" onClick={() => this.props.history.replace("/shoots")}>
                Go back
              </Button>
            </div> */}
          </ContentWrapper>
        </AdminWrapper>
      );
  }
}

export default withStyles(styles)(EditShotShootSteppers);
